export default "__VITE_ASSET__BEGCsS0N__"